export default {
  sans: 'D-DinExp',
  serif: 'Expresso Text Medium',
};



// WEBPACK FOOTER //
// ./src/utils/fonts.js